// Sama paletti kuin myyntihaku.fi: Inter, oranssi aksentti, sage-tausta.
export const theme = {
  color: {
    bg: '#FAFAF8',
    card: '#FFFFFF',
    ink: '#1A1A1A',
    inkSoft: '#3A3A38',
    muted: '#5E5E58',
    line: '#E6E6E0',
    accent: '#FF7F11',
    accentInk: '#B85A0C',
    accentHover: '#E8720F',
    header: '#262626',
    onDark: '#F4F4EE',
    blue: '#B85A0C',
    green: '#5C6B54',
    red: '#A63D24',
    inputBorder: '#E6E6E0',
    rowHover: '#DCE6D4',
    chipBg: '#D5DEC9',
    hover: '#F3F3EF',
    sage: '#ACBFA4',
    cardSage: '#F3F6EA',
  },
  radius: { sm: '6px', md: '8px', lg: '8px', xl: '10px', pill: '8px' },
  font: '15px/1.5 Inter, system-ui, -apple-system, "Segoe UI", sans-serif',
  shadow: '0 1px 2px rgba(26, 26, 26, 0.06)',
} as const;

export type Theme = typeof theme;

declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefaultTheme extends Theme {}
}
